module.exports = __webpack_public_path__ + "static/img/he13.a8ef8e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he13.png
// module id = +zMg
// module chunks = 1